import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CldrIntlService, setData } from '@progress/kendo-angular-intl';
import { lastValueFrom } from 'rxjs';
import { ConfigService } from './config/config.service';

@Injectable({
    providedIn: 'root',
})
export class LocaleService extends CldrIntlService {
    public static readonly DEFAULT_LOCALE_ID = 'en-US';
    public loaded: any = {};
    public currencyCodeSet = false;
    private currencyCode = 'USD';

    constructor(
        @Inject(LOCALE_ID) public thisLocaleId: string,
        private http: HttpClient,
        private readonly configService: ConfigService
    ) {
        const localeId = thisLocaleId || LocaleService.DEFAULT_LOCALE_ID;
        super(localeId);
        this.loadLocaleFile(localeId, false);
    }

    public getLocale() {
        return this.localeId;
    }

    public getCurrencyCode() {
        return this.currencyCode;
    }

    public async loadLocaleFile(localeId: string | undefined | null, forCurrencyCode: boolean): Promise<void> {
        if (!localeId) {
            localeId = LocaleService.DEFAULT_LOCALE_ID;
        }
        if (this.loaded[localeId] && (!forCurrencyCode || (forCurrencyCode && this.currencyCodeSet))) {
            return;
        }

        const localeFilesLocation = this.configService.config.localesUrl;
        try {
            await this.loadLocaleData(`${localeFilesLocation}${localeId}/all.json`, forCurrencyCode);
            this.loaded[localeId] = true;
        } catch (error) {
            if (localeId.includes('-')) {
                const areaLocaleId = localeId.split('-')[0];
                try {
                    await this.loadLocaleData(`${localeFilesLocation}${areaLocaleId}/all.json`, forCurrencyCode);
                    this.loaded[localeId] = true;
                } catch {
                    this.localeId = LocaleService.DEFAULT_LOCALE_ID;
                }
            } else {
                this.localeId = LocaleService.DEFAULT_LOCALE_ID;
            }
        }
    }

    private async loadLocaleData(url: string, forCurrencyCode: boolean): Promise<void> {
        const res = await lastValueFrom(this.http.get<any>(url));

        //We want to set locale data based on client's location
        //but currencyCode/symbol should be based on customer's countrycode
        if (res) {
            if (!forCurrencyCode) {
                setData(res);
            } else if (res['numbers']?.localeCurrency) {
                this.currencyCode = res['numbers']?.localeCurrency;
                this.currencyCodeSet = true;
            }
        }
    }
}
